import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const SloganCardRoot = superstyled({
  name: 'SloganCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: '12px',
    padding: theme.spacing(2, 3),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    backgroundColor: theme.palette.background.paper,
    transition: 'border-color 0.2s ease-in-out',

    '&:hover': {
      borderColor: theme.palette.primary.main
    }
  })
});

export const SloganContent = superstyled({
  name: 'SloganCard',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5)
  })
});

export const SloganText = superstyled({
  name: 'SloganCard',
  slot: 'SloganText',
  tag: Box,
  styles: ({ theme }) => ({
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 600,
    color: theme.palette.text.primary
  })
});

export const SloganInsight = superstyled({
  name: 'SloganCard',
  slot: 'Insight',
  tag: Box,
  styles: ({ theme }) => ({
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: theme.palette.text.secondary
  })
});

export const SloganMeta = superstyled({
  name: 'SloganCard',
  slot: 'Meta',
  tag: Box,
  styles: ({ theme }) => ({
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    color: theme.palette.text.secondary
  })
});

export const ActionsContainer = superstyled({
  name: 'SloganCard',
  slot: 'Actions',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0
  })
});

export const CopyButton = superstyled({
  name: 'SloganCard',
  slot: 'CopyButton',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5),
    borderRadius: '4px',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    transition: 'all 0.2s ease',

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary
    }
  })
});
